<template>
  <div>
    <BlBackdrop
      title="Archive item"
      label="Archive item"
      :submitLoading="submitLoading"
      @backdrop-close="$emit('close-modal')"
      @backdrop-action="onSubmit"
    >
      <div
        class="px-8 flex flex-col gap-2 overflow-y-auto"
        :style="{ width: '40rem', maxHeight: 'calc(100vh - 16rem)' }"
      >
        <div>
          <BlTextBody2 text="You are about to archive" />
          <BlTextBody2 :text="`${creditPackageItem.name}.`" class="font-bold" />
          <BlTextBody2
            v-if="creditPackageItem.packages.length"
            text="This action will affect"
          />
          <BlTextBody2
            v-if="creditPackageItem.packages.length"
            :text="creditPackageItem.packages.length"
            class="font-bold"
          />
          <BlTextBody2
            v-if="creditPackageItem.packages.length"
            text="package(s):"
          />
        </div>
        <div v-if="creditPackageItem.packages.length">
          <div
            v-for="creditPackage in creditPackageItem.packages"
            :key="creditPackage.id"
            class="px-2 flex items-center gap-2"
          >
            <div class="h-1 w-1 flex-shrink-0 bg-slate-800 rounded"></div>
            <BlTextBody2 :text="creditPackage.name" class="font-bold" />
          </div>
        </div>
        <div v-if="!creditPackageItem.packages.length">
          <BlTextBody2
            text="Archiving this item will make it unavailable for new credit transaction."
          />
          <BlTextBody2
            text="However, it will remain linked to any existing appointments or credits."
          />
          <BlTextBody2 text="Are you sure you want to proceed?" />
        </div>
        <div v-else>
          <BlTextBody2
            text="Archiving this item will make it unavailable for new credit transactions and remove it from the affected packages, which will alter the total price and total credits in those packages."
          />
          <BlTextBody2
            text="However, existing transactions that include this item will remain unaffected."
          />
        </div>
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextBody2 from "../../BlTextBody2.vue";

export default {
  name: "ArchivePackageItemModal",
  components: {
    BlBackdrop,
    BlTextBody2
  },
  props: {
    creditPackageItem: { type: Object }
    // @close-modal
  },
  data() {
    return {
      submitLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentCenter"])
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["updateCreditPackageItem"]),
    async onSubmit() {
      const params = {
        id: this.creditPackageItem.id,
        package_item: { status: "archived" },
        title: "Item archived",
        message: `Success! The <b>${this.creditPackageItem.name}</b> has been archived from the center.`
      };

      this.submitLoading = true;
      const { success } = await this.updateCreditPackageItem(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/packageItem/ArchivePackageItemModal.vue